<div class="gt-page-header">
  <h1><i class="fa fa-frown-o"></i> 404 error</h1>
</div>
<div class="gt-page-body-dark">
  <div class="holder-404">
    <img src="assets/img/404.png" alt="404">
    <p>Oops, the requested page could not be found</p>
  </div>
</div>
